"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgJacuzzi = function SvgJacuzzi(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 14.5,
    cy: 7.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 11.5,
    cy: 1.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 7,
    cy: 6,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 4.5,
    cy: 2.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 17,
    cy: 13,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.994 6.5H1.496a1 1 0 0 0-1 1v.006a1 1 0 0 0 1 1h10.692m4.624 0h3.695a1 1 0 0 0 1-1V7.5a1 1 0 0 0-1-1H16.77m-4.51 0H8.007M1.528 8.506v3.01a4 4 0 0 0 4 4l10.936-.05a4 4 0 0 0 4-4v-2.96",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.516 15.48a2.03 2.03 0 0 1-2.03 2.03h-.45m13.437-2.03c0 1.122.91 2.03 2.03 2.03h.45",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgJacuzzi);
var _default = exports["default"] = Memo;